<template>
  </template>

<script>
export default {
  // Mantemos o nome para o Vue nao reclamar que o componente sumiu
  name: 'ChatwootUpdateBanner',
};
</script>
